// ----------------------------------------------------------------------------
// Comparison Table Section
// ----------------------------------------------------------------------------
//
// Handles mobile scroll indicator and swipe functionality for the comparison table.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_comparison-table.scss';

// -------------------------------------
// Variables
// -------------------------------------

var COMPARISON_TABLE_SECTION = '.section--comparison-table';
var COMPARISON_TABLE_CONTAINER = '.comparison-table-container';
var COMPARISON_TABLE_INDICATOR = '.comparison-table__slider-indicator';

// -------------------------------------
// Helper Functions
// -------------------------------------

/**
 * Update the scroll indicator position and visibility
 * @param {HTMLElement} container - The scrollable container
 * @param {HTMLElement} indicator - The scroll indicator element
 */
function updateScrollIndicator(container, indicator) {
  if (!container || !indicator) return;
  var scrollLeft = container.scrollLeft;
  var scrollWidth = container.scrollWidth;
  var clientWidth = container.clientWidth;
  var maxScroll = scrollWidth - clientWidth;
  if (maxScroll <= 0) {
    // No scroll needed, hide indicator
    indicator.style.opacity = '0';
    return;
  }

  // Show indicator
  indicator.style.opacity = '1';

  // Calculate scroll percentage
  var scrollPercentage = scrollLeft / maxScroll * 100;

  // Update indicator width based on visible area
  var visiblePercentage = clientWidth / scrollWidth * 100;
  indicator.style.width = "".concat(visiblePercentage, "%");

  // Calculate transform: account for indicator's own width so it reaches the right edge when fully scrolled
  // The available space for movement is (100% - visiblePercentage%)
  // So we multiply scrollPercentage by the available space percentage
  var availableSpace = 100 - visiblePercentage;
  var left = scrollPercentage * (availableSpace / 100);
  indicator.style.left = "".concat(left, "%");
}

// -------------------------------------
// Helper: Debounce function
// -------------------------------------

/**
 * Creates a debounced function that delays execution
 * @param {Function} func - Function to debounce
 * @param {number} wait - Delay in milliseconds
 * @returns {Function} Debounced function
 */
function debounce(func, wait) {
  var timeout;
  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// -------------------------------------
// Initialize
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var comparisonSections = document.querySelectorAll(COMPARISON_TABLE_SECTION);

  // Shared resize handler for all sections
  var handleResize = debounce(() => {
    comparisonSections.forEach(section => {
      var container = section.querySelector(COMPARISON_TABLE_CONTAINER);
      var indicator = section.querySelector(COMPARISON_TABLE_INDICATOR);
      if (container && indicator) {
        updateScrollIndicator(container, indicator);
      }
    });
  }, 100);
  comparisonSections.forEach(section => {
    var container = section.querySelector(COMPARISON_TABLE_CONTAINER);
    var indicator = section.querySelector(COMPARISON_TABLE_INDICATOR);
    if (!container || !indicator) return;

    // Initial update
    updateScrollIndicator(container, indicator);

    // Update on scroll (debounced for performance)
    var handleScroll = debounce(() => {
      updateScrollIndicator(container, indicator);
    }, 10);
    container.addEventListener('scroll', handleScroll, {
      passive: true
    });
  });

  // Single resize listener for all sections
  window.addEventListener('resize', handleResize, {
    passive: true
  });
});